module.exports = __webpack_public_path__ + "static/media/quality.dd26e416.png";